/**
 * Single source of truth for the "PRS.NET® ERP v1.NNN" label shown in the
 * header / menu.
 *
 * The minor counter is baked into the bundle via `generatedBuildVersion.js`.
 * `scripts/generateBuildVersion.js` also writes `public/build-version.json`;
 * MenuBar uses `useLiveBuildVersionLabel` to fetch that JSON (no-store) on load
 * so the label matches the last generator run even when the dev bundle lags slightly.
 */
import { BUILD_AT, BUILD_COUNTER } from "./generatedBuildVersion";

const APP_NAME = "PRS.NET® ERP";
const MAJOR_VERSION = 1;
const COUNTER_PAD = 3;

/** Build label from numeric counter (same rules as generator `public/build-version.json`). */
export function formatBuildVersionLabel(counter) {
  const n = Math.max(0, Math.floor(Number(counter) || 0));
  const minor = String(n).padStart(COUNTER_PAD, "0");
  return `${APP_NAME} v${MAJOR_VERSION}.${minor}`;
}

export function getAppVersionLabel() {
  return formatBuildVersionLabel(BUILD_COUNTER);
}

/** URL to static JSON written by `scripts/generateBuildVersion.js` (CRA `public/`). */
export function getBuildVersionJsonUrl() {
  const base = String(process.env.PUBLIC_URL || "").replace(/\/$/, "");
  return `${base}/build-version.json`;
}

/** Optional: short build identifier for tooltips / debug screens. */
export function getBuildInfo() {
  return {
    counter: BUILD_COUNTER,
    builtAt: BUILD_AT,
    label: getAppVersionLabel(),
  };
}
